import { render, staticRenderFns } from "./FacebookLogin.vue?vue&type=template&id=90c3f0d6&"
import script from "./FacebookLogin.vue?vue&type=script&lang=js&"
export * from "./FacebookLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports